import { IAppState } from '../../../AppModulesWrapper';

export const selectCurrency = (state: IAppState) => {
  const { offer } = state.servicePickerWidget;

  return offer.bargainTerms.currency;
};
